module.exports = __webpack_public_path__ + "img/phone.90583d29.png";